export const FETCH_CAMPAIGN_NAME = 'FETCH_CAMPAIGN_NAME';
export const FETCH_CAMPAIGN_NAME_SUCCESS = `${FETCH_CAMPAIGN_NAME}_SUCCESS`;
export const FETCH_CAMPAIGN_NAME_FAIL = `${FETCH_CAMPAIGN_NAME}_FAIL`;
const fetchExtractCampaignNameReducer = (
  state = {
    isLoading: false,
    isLoaded: false,
    error: null,
  },
  action = {},
) => {
  switch (action.type) {
    case FETCH_CAMPAIGN_NAME:
      return { ...state, isLoading: true };
    case FETCH_CAMPAIGN_NAME_SUCCESS:
      return {
        ...state,
        name: action.payload.data.loyaltyBalanceCampaign[0].campaignName,
        isLoading: false,
        isLoaded: true,
      };
    case FETCH_CAMPAIGN_NAME_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default fetchExtractCampaignNameReducer;
